/**
 * Returns a list of passive endings
 *
 * @returns {string[]} Turkish passive verb endings.
 */
export default function() {
	return [
		"nmak",
		"nmek",
		"nir",
		"nır",
		"nür",
		"nur",
		"nıyor",
		"niyor",
		"ndı",
		"ndi",
		"ndu",
		"ndü",
		"nmış",
		"nmiş",
		"nmuş",
		"nmüş",
		"necek",
		"nacak",
		"nmıştı",
		"nmişti",
		"nmuştu",
		"nmüştü",
		"nıyordu",
		"niyordu",
		"nuyordu",
		"nüyordu",
		"necekti",
		"nacaktı",
		"nsa",
		"nse",
		"nmalı",
		"nmeli",
		"nmaz",
		"nmez",
		"anmak",
		"enmek",
		"ınmak",
		"inmek",
		"unmak",
		"ünmek",
		"anır",
		"enir",
		"ınır",
		"inir",
		"unur",
		"ünür",
		"anıyor",
		"eniyor",
		"ınıyor",
		"iniyor",
		"unuyor",
		"ünüyor",
		"andı",
		"endi",
		"ındı",
		"indi",
		"undu",
		"ündü",
		"anmış",
		"enmiş",
		"ınmış",
		"inmiş",
		"unmuş",
		"ünmüş",
		"anacak",
		"enecek",
		"ınacak",
		"inecek",
		"unacak",
		"ünecek",
		"ınmıştı",
		"inmişti",
		"unmuştu",
		"ünmüştü",
		"ınıyordu",
		"iniyordu",
		"unuyordu",
		"ünüyordu",
		"necekti",
		"nacaktı",
		"ansa",
		"ense",
		"ınsa",
		"inse",
		"unsa",
		"ünse",
		"anmalı",
		"enmeli",
		"ınmalı",
		"inmeli",
		"unmalı",
		"ünmeli",
		"anmaz",
		"enmez",
		"ınmaz",
		"inmez",
		"unmaz",
		"ünmez",
		"ılmak",
		"ilmek",
		"ulmak",
		"ülmek",
		"ılır",
		"ilir",
		"ulur",
		"ülür",
		"ılınıyor",
		"iliniyor",
		"ulunuyor",
		"ülüyor",
		"ıldı",
		"ildi",
		"uldu",
		"üldü",
		"ılmış",
		"ilmiş",
		"ulmuş",
		"ülmül",
		"ılacak",
		"ilecek",
		"ulacak",
		"ülecek",
		"ılmıştı",
		"ilmişti",
		"ulmuştu",
		"ülmüştü",
		"ılıyordu",
		"iliyordu",
		"uluyordu",
		"ülüyordu",
		"necekti",
		"nacaktı",
		"ılsa",
		"ilse",
		"ulsa",
		"ülse",
		"ılmalı",
		"ilmeli",
		"ulmalı",
		"ülmeli",
		"ılmaz",
		"ilmez",
		"ulmaz",
		"ülmez",
	];
}
